export const formatNumber = (val: number | string) => {
  if (typeof val === "number") {
    return val.toLocaleString("en-IN");
  }
  return val;
};